import styled from 'styled-components/macro';

export default styled.h1`
  padding: 20px 0 0 44px;
  display: flex;
  align-items: center;
`;
